import { render } from "./OltpGraphVisualizer.vue?vue&type=template&id=0f139880"
import script from "./OltpGraphVisualizer.vue?vue&type=script&lang=js"
export * from "./OltpGraphVisualizer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__